export class LoyaltyCardReward {
  public id: string;
  public name: string;
  public url: string;
  public at: number;
  public statcode: string;
  public logoUrl: string;
  public title: string;
  public description: string;
}
